import {
    DEFAULT_SEARCH_COLUMNS,
    DEFAULT_SEARCH_PAGE,
    DEFAULT_SORT_ORDER,
    DOWNLOAD_THRESHOLD_MANY_OBJECTS,
    MAX_RESULTS_PER_PAGE,
    ObjectTypeId,
    REQUEST_THROTTLE,
    REQUEST_THROTTLE_QUICK,
    SPINNER
} from "../../constants";
import {
    IImportHrFile,
    IMessageData,
    IObjectData,
    IObjectType,
    IResponse,
    IRouteDefinition,
    IRouteDefinitionParams,
    IRule,
    IRuleset,
    ISearchGroupMemberParams,
    ISearchObjectParams,
    ISearchParams,
    ISyncField,
    ITableColumn,
    TBaseOrObservableType,
    TDataSourceType,
    TDeleted,
    TSyncfield,
} from "../../index";
import {_} from 'lodash';
import {global, lm} from "../../appContext";
import {customStoreObservable, storeObservable, TStoreId} from "../../util/sessionstore";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {
    _d,
    canManageOthersPassword,
    createErrorMessage,
    getObjectDefinition,
    getObjectType,
    getRawSyncFieldValue,
    getSearchMarkup,
    getSourceTranslation,
    getSyncField,
    getSyncFieldDisplayName,
    getSyncFieldValue,
    getWhiteWashedSearchKey,
    hasMultipleImportFormatTypes
} from "../../util/misc";
import {memoryStore} from "../../util/memorystore";
import {IComponentDialogParams} from "../modal/component";
import pubsub from "../../pubsub";
import {nsFa} from "../fa/fn";
import {nsRuleset} from "../ruleset/nsRuleset";
import {getSearchObjectParams, getSearchParamsFn} from "../../util/request";
import {getDateTime, getHrFileDate} from "../../util/datetime";
import {
    getChildHash,
    getHash,
    getRouteDefinition,
    getRouteDropdownButton,
    getRouteHash,
    setRouteHash
} from "../../constants/RouteDefinitions";
import {nsRoute} from "../../util/route";
import {TComponentName} from "../../constants/ComponentRegistry";
import {TServiceName} from "../../constants/ApiServices";
import {nsSyncFields} from "../../req/nsSyncFields";
import {nsSearch, PLEASE_WAIT_MESSAGE, REQUEST_MESSAGE} from "../../constants/Language";
import {IRequestObject} from "../../req/index";
import {nsLanguage} from "../../util/nsLanguage";
import {nsSearchToggle} from "../search/nsSearchToggle";
import PromiseRequest from "../../req/PromiseRequest";
import {IComboboxV2Options} from "../combobox/v2";
import {createServiceListPromise} from "../combobox/v2-sources";
import {ICustomSystemAccess, IComboboxOptions_SystemRole} from "../combobox/system-role";
import {nsTooltip} from "../../util/nsTooltip";
import {IComboboxOptions_Ruleset} from "../combobox/ruleset";
import {IComboboxOptions_Department, TObjectData_basicDepartment} from "../combobox/department";
import * as ko from "knockout";
import {ISplitButtonParams} from "../button/splitButton/split-button";
import {IDialogOptionsComponent} from "../dialog";
import {ISearchObjectRouteOptions} from "./index";
import {WIZARD_PERMISSIONS_PREFILL_USERS_KEY} from "../permission/wizardPrefill";
import {IDropdownButton} from "../button";
import {ISelectedListActions} from "./selected-list";
import {nsDataSource} from "../../util/nsDataSource";
import {Syncfield_ObjectTypeId_DataSource} from "../../constants/Syncfields";
import {getHashQueryFlag, getHashQueryNumber, getHashQueryParams} from "../../util/hashQuery";
import {getSearchBoxHeadingKey} from "../search/boxHeadingKey";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import AllCheckbox = nsSearchToggle.AllCheckbox;
import ItemCheckbox = nsSearchToggle.ItemCheckbox;
import getSyncfieldIdsFromNames = nsSyncFields.getSyncfieldIdsFromNames;
import i = nsFa.i;
import searchHtml from './search.html?raw';

export let template: string = searchHtml;

export interface IObjectSearchParams extends IRouteDefinitionParams {
    autoRequest?: boolean
    autoSelect?: boolean
    fnValidateRow?: (obj: IObjectData) => boolean
    getRowBindings?: (obj: IObjectData) => any
    hasFocus?: TBaseOrObservableType<boolean>
    /** Extra selected-list command-bar actions (next to Clear selection). */
    selectedListActions?: TBaseOrObservableType<ISelectedListActions | null | undefined>
    isSelectable?: boolean
    searchtotalresults?: KnockoutObservable<number | null>
    selectedObjects?: KnockoutObservableArray<IObjectData>
    serviceName?: TServiceName
    syncstepid?: number
    syncfieldNames?: TSyncfield[]
}

export enum FilterType {
    Deleted,
    Department,
    ImportCycle,
    Permission,
    SystemRole,
    Ruleset,
    PermissionType,
    Subdepartment,
    DataSourceType,
    IdentityType,
}

export enum OperationType {
    Delete,
    Export,
    ExportAnchor,
    ExportMembers,
    Recreate,
    ResetPasswords,
    AssignPermissions,
    CreateSystemAccessAndRoles,
    RemoveManualPermission,
}

type TPermissionType = 'manual' | 'automatic' | 'all';

export interface IFilterOptions {
    deleted: KnockoutObservable<TDeleted>
    department: KnockoutObservable<TObjectData_basicDepartment | null>
    department_secondaryPositions: KnockoutObservable<boolean | null>
    department_subdepartments: KnockoutObservable<boolean | null>
    importFile: KnockoutObservable<IImportHrFile | null>
    permission: KnockoutObservable<ICustomSystemAccess | null>
    permissionType: KnockoutObservable<TPermissionType>
    ruleset: KnockoutObservable<IRuleset | null>
    subdepartment: KnockoutObservable<TObjectData_basicDepartment | null>
    dataSourceType: KnockoutObservable<TDataSourceType>
    identityType: KnockoutObservable<'Staff' | 'Learner' | null>
}

export class viewModel extends ParsedRouteDataDecorator {
    private ObjectTypeId = ObjectTypeId;

    FilterType = FilterType;
    OperationType = OperationType;

    protected readonly data: KnockoutObservableArray<IObjectData> = ko.observableArray<IObjectData>([]);
    private readonly data_currentSearch_ids: KnockoutObservableArray<number> = ko.observableArray<number>([])
    protected readonly isRequesting: KnockoutObservable<boolean> = ko.observable(false);
    protected readonly isReady: KnockoutObservable<boolean> = ko.observable(false);
    protected pageMessage: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);

    readonly isManual: boolean;
    readonly isSelectable: boolean;
    readonly selectedObjects: KnockoutObservableArray<IObjectData>;
    readonly syncstepid: number;
    readonly hasFocus: KnockoutObservable<boolean>;

    protected readonly isAnySelected = ko.pureComputed((): boolean => !!this.selectedObjects().length);
    protected readonly searchascending: KnockoutObservable<boolean>;
    protected readonly searchcolumn: KnockoutObservable<string>;
    protected readonly searchkey: KnockoutObservable<string>;
    protected readonly searchpagenr: KnockoutObservable<number>;
    protected readonly searchpages: KnockoutObservable<number | null> = ko.observable(null);
    protected readonly searchtotalresults: KnockoutObservable<number | null>;
    protected readonly searchresultsprpage = storeObservable("num.search.results");
    protected readonly showAll: KnockoutObservable<boolean>;
    protected readonly routeOptions?: ISearchObjectRouteOptions

    // -----------------------------------------------------------------------------------------------------------------
    // Search filter options
    // -----------------------------------------------------------------------------------------------------------------
    protected filterOptions = {} as IFilterOptions

    protected requests: Partial<Record<TServiceName, PromiseRequest>> = {}

    private readonly allRulesets: KnockoutObservableArray<IRuleset> = ko.observableArray<IRuleset>([]);

    protected kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    private throttleTimeout: number | undefined
    protected readonly req_searchobject: PromiseRequest
    protected readonly req_searchobject_ids: PromiseRequest

    protected pv = global.permissionValidator;
    protected params: IObjectSearchParams;
    private childRouteDef: IRouteDefinition;

    protected isInitialDepartment?: (o: TObjectData_basicDepartment) => boolean
    protected serviceName: TServiceName;
    private syncfields: KnockoutObservable<ISyncField[] | null> = ko.observable(null);
    protected response!: IResponse;

    private req_syncfields!: IRequestObject
    private syncfieldIds!: string;

    protected checkedKey: keyof IObjectData = 'id';

    protected allCheckbox: AllCheckbox<IObjectData>

    readonly searchSplitButtonParams: KnockoutComputed<Pick<ISplitButtonParams, 'mainButton' | 'buttons'> | null>

    protected comboboxParams_ruleset!: IComboboxOptions_Ruleset;
    protected comboboxParams_importHistory!: IComboboxV2Options<IImportHrFile>;
    protected comboboxParams_systemRole!: IComboboxOptions_SystemRole;
    protected comboboxParams_department!: IComboboxOptions_Department;
    protected comboboxParams_subdepartment!: IComboboxOptions_Department;

    private readonly objectType: IObjectType;

    /** Object routes always carry an object type id from the route definition. */
    protected get routeObjectTypeId(): ObjectTypeId {
        return this.__objectTypeId!;
    }

    constructor(params: IObjectSearchParams) {
        super(params);

        try {
            // Seed search state from hash query (?systemid=&roleid=&showAll=&resetFilters=).
            const q = getHashQueryParams();
            const resetFilters = getHashQueryFlag(q, 'resetFilters');
            const showAll = getHashQueryFlag(q, 'showAll');
            const roleid = getHashQueryNumber(q, 'roleid');
            const systemid = getHashQueryNumber(q, 'systemid');
            if (resetFilters !== undefined || showAll !== undefined || roleid !== undefined || systemid !== undefined) {
                this.routeOptions = {
                    ...(resetFilters ? {$resetFilters: true} : {}),
                    ...(showAll !== undefined ? {showAll} : {}),
                    ...(roleid !== undefined ? {roleid} : {}),
                    ...(systemid !== undefined ? {systemid} : {}),
                };
            }
        } catch {
            _d.warn('Failed to parse route options')
        }
        this.params = _.defaults(params, {
            fnValidateRow: () => true,
            getRowBindings: () => null,
            hasFocus: false,
            isManual: !!this.__routeDef.manual,
            isRequesting: this.isRequesting,
            isSelectable: true,
            searchtotalresults: ko.observable<number | null>(null),
            selectedObjects: ko.observableArray<IObjectData>([]),
            serviceName: 'searchobject' as TServiceName,
            syncstepid: 0,
        });

        this.objectType = getObjectType(this.routeObjectTypeId)
        this.childRouteDef = getRouteDefinition(this.__routeDef.child!)!;
        this.isManual = !!this.__routeDef.manual;
        this.searchSplitButtonParams = ko.pureComputed(() => this.buildSearchSplitButtonParams())
        this.isSelectable = this.params.isSelectable!;
        this.searchtotalresults = this.params.searchtotalresults!;
        this.selectedObjects = this.params.selectedObjects!;
        this.syncstepid = this.params.syncstepid!;
        this.serviceName = this.params.serviceName!;

        this.req_searchobject_ids = global.getPromiseRequest(this.serviceName)
        this.req_searchobject = global.getPromiseRequest(this.serviceName)

        this.allCheckbox = new AllCheckbox({
            data: this.data,
            fnIsSelectable: (obj: IObjectData) => this.params.fnValidateRow!(obj),
            key: 'id',
            selected: this.selectedObjects,
            dropdownParams: {
                numPageItems: () => this.data().filter(o => this.params.fnValidateRow!(o)).length,
                total: () => this.getSelectableSearchIds().length,
                toggle_all: () => {
                    const searchIds = this.getSelectableSearchIds()
                    const selectedIds = this.selectedObjects().map(o => o.id)
                    const delta = _.difference(searchIds, selectedIds)

                    const fnToggleAll = () => {
                        this.isRequesting(true)
                        this.messageData({message: PLEASE_WAIT_MESSAGE})

                        const ruleset = nsRuleset.generateRuleset({
                            authdatasources: this.filterOptions.dataSourceType(),
                            objecttype: this.objectType,
                            rules: [nsRuleset.generateRule({
                                attribute: 'Id',
                                argumentoperator: 'Inneholder en av',
                                argument: delta.join(','),
                            })],
                        })

                        const params = {
                            jruleset: JSON.stringify(ruleset),
                            pagenr: 0,
                            resultsprpage: MAX_RESULTS_PER_PAGE,
                        }

                        this.doRequest(params)
                            .then((response: IResponse) => {
                                this.selectedObjects.push(...response.data.filter(o => this.params.fnValidateRow!(o)))
                                this.messageData(null)
                                this.isRequesting(false)
                            })
                            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
                    }

                    const isAddingManyObjects = delta.length > DOWNLOAD_THRESHOLD_MANY_OBJECTS
                    if (isAddingManyObjects) {
                        const objectsPlural = `((${getObjectDefinition(this.routeObjectTypeId)?.plural ?? ''}|ac))`
                        global.dialogManager.addConfirm({
                            buttons: {
                                confirm: {
                                    onClick: () => fnToggleAll(),
                                    label: 'Yes, continue',
                                },
                                cancel: {
                                    label: 'No, cancel',
                                }
                            },
                            title: `${i('fa-exclamation-triangle')} ${lm.t(`Many objects|s:((${objectsPlural}))`) ?? ''}`,
                            content: lm.t(`<p>((You are about to add many objects|s:${objectsPlural}))</p><p>((are you sure you want to continue))</p>`) ?? '',
                        })
                    } else {
                        fnToggleAll()
                    }
                },
                isChecked_all: () => {
                    const selectableIds = this.getSelectableSearchIds()
                    if (!selectableIds.length) {
                        return false
                    }
                    const selectedIds = this.selectedObjects().map(o => o.id)
                    return selectableIds.every(id => selectedIds.includes(id))
                },
            }
        })

        this.showAll = customStoreObservable(this.__routeId + '.show.all', false);
        if (this.routeOptions && 'showAll' in this.routeOptions) {
            this.showAll(!!this.routeOptions.showAll);
        }
        this.hasFocus = ko.isObservable(this.params.hasFocus)
            ? this.params.hasFocus as KnockoutObservable<boolean>
            : ko.observable(!!this.params.hasFocus);
        if (this.showAll()) {
            this.hasFocus(false);
        }

        this.setFilterObservables();
        this.searchkey = memoryStore.get(this.__routeId + '.searchkey', '')
        this.searchpagenr = memoryStore.get(this.__routeId + '.pagenr', DEFAULT_SEARCH_PAGE)
        this.searchascending = memoryStore.get(this.__routeId + '.searchascending', DEFAULT_SORT_ORDER)
        this.searchcolumn = memoryStore.get(this.__routeId + '.searchcolumn', this.getInitialSearchColumn())

        global.resetObservableOnOrganizationChange(this.filterOptions.department, null);
        global.resetObservableOnOrganizationChange(this.filterOptions.importFile, null);
        global.resetObservableOnOrganizationChange(this.filterOptions.ruleset, null);
        global.resetObservableOnOrganizationChange(this.filterOptions.permission, null);
        global.resetObservableOnOrganizationChange(this.filterOptions.permissionType, 'all');
        global.resetObservableOnOrganizationChange(this.filterOptions.subdepartment, null);
        global.resetObservableOnOrganizationChange(this.filterOptions.dataSourceType, nsDataSource.getImportFormatType(global.login.selectedOrganization()!.importformat));
        global.resetObservableOnOrganizationChange(this.filterOptions.identityType, null);
        global.resetObservableOnOrganizationChange(this.searchpagenr, 0);
        global.resetObservableOnOrganizationChange(this.selectedObjects, []);
        global.resetTrgObsWhenSrcObsChange(this.searchresultsprpage, this.searchpagenr, 0);

        this.kosub.subscribe(storeObservable('language'), () => {
            Promise.resolve()
                .then(() => this.initSyncfields())
                .then(() => this.initEnd())
        });

        this.kosub.subscribe(this.filterOptions.dataSourceType, dataSourceType => {
            this.data.removeAll()
            this.selectedObjects.removeAll()
            if (dataSourceType == 'hr') {
                this.filterOptions.identityType(null);
            }
        });

        [
            this.filterOptions.deleted,
            this.filterOptions.department,
            this.filterOptions.department_secondaryPositions,
            this.filterOptions.department_subdepartments,
            this.filterOptions.importFile,
            this.filterOptions.permission,
            this.filterOptions.permissionType,
            this.filterOptions.ruleset,
            this.filterOptions.subdepartment,
            this.filterOptions.dataSourceType,
            this.filterOptions.identityType,
            this.searchascending,
            this.searchcolumn,
            this.searchresultsprpage,
            storeObservable(`search.object.syncfields${this.routeObjectTypeId}` as TStoreId)
        ].forEach(obs => this.kosub.subscribe(obs, () => {
            this.preSubmit()
        }));

        this.kosub.subscribe(this.searchpagenr, () => this.preSubmit(false, false));
        this.kosub.subscribe(this.searchkey, () => this.preSubmit(true, true, REQUEST_THROTTLE));

        this.kosub.subscribe(this.showAll, (bool: boolean) => {
            requestAnimationFrame(() => this.hasFocus(!bool));
            this.preSubmit();
        });

        this.kosub.subscribe(global.login.selectedOrganization, () => this.preSubmit());

        ["search.object.needs.refresh", "ruleset.created", "ruleset.updated"].forEach(e => pubsub.on(this, e, () => {
            global.cacheManager.removeCache('searchobject')
            this.resetSearch();
            this.preSubmit(true, true, 0);
        }))

        if (params.autoRequest !== false) {
            this.init()
        }
    }

    protected init(): Promise<any> {
        return Promise.resolve()
            .then(() => this.initStart())
            .then(() => this.initSyncfields())
            .then(() => this.initMain())
            .then(() => this.initEnd())
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
    }

    protected initStart(): Promise<any> {
        return Promise.resolve()
            .then(() => {
                this.isReady(false);
                this.pageMessage({message: REQUEST_MESSAGE})
            })
    }

    protected initSyncfields(): Promise<any> {
        this.req_syncfields?.promise.abort()
        this.req_syncfields = nsSyncFields.getSyncFields(this.routeObjectTypeId)
        this.req_syncfields.request
            .then((data: ISyncField[]) => this.syncfields(data.length ? data : null))
            .catch((reason) => {
                this.messageData(createErrorMessage(String(reason)))
            })
        return this.req_syncfields.request
    }

    protected initMain(): Promise<void> {
        return Promise.resolve()
    }

    protected initEnd(): Promise<any> {
        return Promise.resolve()
            .then(() => {
                this.isReady(true)
                this.pageMessage(null)
                this.preSubmit(false, false, 0)
            })
    }

    protected setFilterObservables(observables?: Partial<IFilterOptions>) {
        this.filterOptions.deleted = observables?.deleted ?? memoryStore.get(this.__routeId + 'filter.option.deleted', 1);
        this.filterOptions.department = observables?.department ?? memoryStore.get(this.__routeId + 'filter.option.department', null);
        this.filterOptions.department_secondaryPositions = observables?.department_secondaryPositions ?? memoryStore.get(this.__routeId + 'filter.option.department_secondaryPositions', null);
        this.filterOptions.department_subdepartments = observables?.department_subdepartments ?? memoryStore.get(this.__routeId + 'filter.option.department_subdepartments', null);
        this.filterOptions.importFile = observables?.importFile ?? memoryStore.get(this.__routeId + 'filter.option.importfile', null);
        this.filterOptions.permission = observables?.permission ?? memoryStore.get(this.__routeId + 'filter.option.permission', null);
        this.filterOptions.permissionType = observables?.permissionType ?? memoryStore.get(this.__routeId + 'filter.option.permissionType', 'all');
        this.filterOptions.ruleset = observables?.ruleset ?? memoryStore.get(this.__routeId + 'filter.option.ruleset', null);
        this.filterOptions.subdepartment = observables?.subdepartment ?? memoryStore.get(this.__routeId + 'filter.option.subdepartment', null);
        this.filterOptions.dataSourceType = observables?.dataSourceType ?? memoryStore.get(this.__routeId + 'filter.option.datasourcetype', nsDataSource.getImportFormatType(global.login.selectedOrganization()!.importformat));
        this.filterOptions.identityType = observables?.identityType ?? memoryStore.get(this.__routeId + 'filter.option.identityType', null);

        if (this.routeOptions?.$resetFilters) {
            this.onResetClick()
        }

        this.comboboxParams_ruleset = this.getComboboxParams_ruleset()
        this.comboboxParams_importHistory = this.getComboboxParams_importHistory()
        this.comboboxParams_systemRole = this.getComboboxParams_systemRole()
        this.comboboxParams_department = this.getComboboxParams_department()
        this.comboboxParams_subdepartment = this.getComboboxParams_subdepartment()
    }

    protected getTableKeys(): string[] {
        let keys: string[] = ['selector'];
        keys = keys.concat(storeObservable(`search.object.syncfields${this.routeObjectTypeId}` as TStoreId)())
            .filter(key => this.showTableColumn(key))
            .filter(key => {
                const dataSourceType = Syncfield_ObjectTypeId_DataSource[this.routeObjectTypeId]
                if (!dataSourceType) {
                    return true
                }
                switch (this.filterOptions.dataSourceType()) {
                    case 'hr':
                    case 'edu':
                        const keyDataSource = dataSourceType[key as keyof typeof dataSourceType];
                        return keyDataSource?.includes(this.filterOptions.dataSourceType()) ?? true
                    default:
                        return true
                }
            })
        return keys;
    }

    protected getTableDefinition(): ITableColumn[] {
        const keys: string[] = this.getTableKeys();

        return keys.map((k: string) => {
            const ret: ITableColumn = {
                key: k,
                sort: false,
            };
            switch (k) {
                case 'selector':
                    ret.label = '';
                    return ret;
                case 'func':
                    ret.label = '';
                    return ret;
                case 'EntryType':
                    ret.sort = false;
                    return ret;
                default:
                    ret.sort = true;
                    return ret;
            }
        });
    }

    private translate(key: string): string {
        const sf = getSyncField(key as TSyncfield, this.syncfields() ?? [])
        if (sf) {
            return getSourceTranslation(sf)
        } else {
            return lm.t(key) ?? ''
        }
    }

    private getHeaderTitle(key: string): string | undefined {
        const sf = getSyncField(key as TSyncfield, this.syncfields() ?? [])
        return sf?.description
    }

    /*******************************************************************************************************************
     * Client/Server stuff
     *******************************************************************************************************************/

    protected preSubmit(resetPagenr: boolean = true, resetPages: boolean = true, throttleDuration: number = REQUEST_THROTTLE_QUICK) {
        this.messageData(null)
        if (resetPagenr) {
            this.searchpagenr(DEFAULT_SEARCH_PAGE);
        }
        if (resetPages) {
            this.searchpages(null);
        }

        if (!global.login.selectedOrganization() || !this.hasSearchKey()) {
            this.resetSearch();
            return;
        }
        if (!this.isReady()) {
            return
        }

        this.isRequesting(true)
        clearTimeout(this.throttleTimeout)

        this.req_searchobject_ids.abort()
        this.req_searchobject.abort()

        if (throttleDuration) {
            this.throttleTimeout = setTimeout(() => {
                this.throttleTimeout = undefined
                this.onSubmit().then(() => this.isRequesting(false));
            }, throttleDuration)
            return
        } else {
            this.onSubmit().then(() => this.isRequesting(false))
        }
    }

    protected async onSubmit() {
        return Promise.resolve()
            .then(() => {
                if (!this.isCheckboxesAvailable()) {
                    return
                }
                const params = _.defaults({
                    onlyids: true,
                    resultsprpage: MAX_RESULTS_PER_PAGE,
                    pagenr: 0,
                }, this.getParams())
                return this.req_searchobject_ids
                    .request(params, false)
                    .then((ids: string[]) => this.data_currentSearch_ids(ids.map(str => Number(str))))
            })
            .then(() => {
                return this.doRequest()
                    .then((resp: IResponse) => {
                        this.onSuccess(resp)
                    })
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
                this.searchtotalresults(0)
            })
    }

    private async doRequest(params?: Partial<ISearchObjectParams>): Promise<IResponse> {
        const syncfieldNames = this.getSearchColsArr() as TSyncfield[]
        const syncfieldids: string = await getSyncfieldIdsFromNames(this.routeObjectTypeId, ...syncfieldNames)
        const onlytuples = this.routeObjectTypeId != ObjectTypeId.FormData
        const _params = _.defaultsDeep(params, {onlytuples, syncfieldids}, this.getParams())

        return this.req_searchobject
            .request(_.defaultsDeep(params ?? {}, _params), true)
            .then((response: IResponse) => {
                if (onlytuples) {
                    const relevantSyncfieldsSorted = _(this.syncfields() ?? [])
                        .filter((sf: ISyncField) => syncfieldNames.includes(sf.name))
                        .sortBy((sf: ISyncField) => syncfieldNames.indexOf(sf.name))
                        .value()
                    const ret = _.cloneDeep(response)
                    ret.data = ret.data.map((values: string[]) => {
                        return {
                            id: Number(values[syncfieldNames.indexOf('Id')]),
                            type: this.objectType,
                            syncfields: relevantSyncfieldsSorted.map((sf: ISyncField, index: number) => {
                                return _.defaultsDeep({value: values[index]}, sf)
                            }),
                        }
                    })
                    return ret
                } else {
                    return response
                }
            })
    }

    protected getParams(...parameters: Partial<ISearchObjectParams>[]): ISearchObjectParams | ISearchGroupMemberParams | ISearchParams {
        let deleted: TDeleted;
        if (this.isRulesetNestedDelete()) {
            deleted = -1
        } else {
            deleted = Number(this.filterOptions.deleted()) as TDeleted
        }
        return getSearchObjectParams({
            asc: this.searchascending(),
            deleted: deleted,
            importfileid: this.filterOptions.importFile()?.id ?? 0,
            jruleset: this.getRuleset() ? JSON.stringify(this.getRuleset()) : '',
            manualobjects: this.isManual,
            objecttypeid: this.routeObjectTypeId,
            pagenr: this.searchpagenr(),
            resultsprpage: this.searchresultsprpage(),
            searchcols: this.getSearchCols(),
            searchkey: this.getRealSearchKey(),
            sortcol: this.searchcolumn(),
            syncfieldids: this.syncfieldIds,
            syncstep: this.syncstepid,
        }, ...parameters);
    }

    protected getSearchColsArr(): string[] {
        const ret: string[] = this.table()
            .filter(item => item.sort)
            .map(item => item.key)
            .map(item => String(item))

        const onlytuples = this.routeObjectTypeId != ObjectTypeId.FormData
        if (onlytuples) {
            if (!ret.includes('Id')) {
                ret.unshift('Id')
            }
        }
        if (this.routeObjectTypeId == ObjectTypeId.User) {
            if (!ret.includes('DisplayName') && ret.includes('GivenName') && ret.includes('Surname')) {
                ret.push('DisplayName')
            }
        }
        return _.uniq(ret)
    }

    protected getSearchCols(): string {
        return this.getSearchColsArr().join(',')
    }

    protected getRuleset(rules: Partial<IRule>[] = [] /* this will be (further) populated below */): IRuleset | null {
        const foRuleset = _.cloneDeep(this.filterOptions.ruleset());
        const foPermission = _.cloneDeep(this.filterOptions.permission());
        const foPermissionType = _.cloneDeep(this.filterOptions.permissionType());
        const foDepartment = _.cloneDeep(this.filterOptions.department());
        const foDepartment_subdepartments = this.filterOptions.department_subdepartments();
        const foDepartment_secondaryPositions = this.filterOptions.department_secondaryPositions();
        const foSubdepartment = this.filterOptions.subdepartment();
        const foDataSourceType = this.filterOptions.dataSourceType();
        const foIdentityType = this.filterOptions.identityType();

        const noNeedForRuleset = !(foRuleset || foPermission || foDepartment) && !rules.length && !foSubdepartment && !foDataSourceType && !foIdentityType;
        if (noNeedForRuleset) {
            return null;
        }

        const companyid = global.login.selectedOrganizationId();

        const ruleset = nsRuleset.generateRuleset({
            authdatasources: foDataSourceType,
            ...(companyid ? {companyid} : {}),
            objecttype: getObjectType(this.routeObjectTypeId),
        })

        // --- Start populating rules ---

        if (foRuleset) {
            rules.push({
                argument: foRuleset.id,
                argumentoperator: 'Omfattes av',
            });
        }

        if (this.routeObjectTypeId == ObjectTypeId.User && foPermission) {
            const type = foPermission.role ? 'SYSTEMROLE' : 'SYSTEM';

            if (foPermissionType == 'all') {
                rules.push({
                    argumentoperator: `Har verdi`,
                    attribute: `[OBJECTPERMISSION.${type};Id;Id;${foPermission.id};true;true]`,
                })
            } else {
                const attribute = foPermission.role
                    ? `[OBJECTPERMISSION;Manual;SystemRoleId;${foPermission.id}]`
                    : `[OBJECTPERMISSION;Manual;SystemId;${foPermission.id};true;true]`
                const argument = foPermissionType == 'manual'
                    ? 'True,true'
                    : 'False,false'
                rules.push({
                    argument: argument,
                    attribute: attribute,
                    argumentoperator: 'Inneholder en av',
                })
            }

        }

        if (this.routeObjectTypeId == ObjectTypeId.User && foDepartment) {
            const t = nsSyncFields.getSourceToTargetTuples({
                key: 'DepartmentNumber',
                srcObjectTypeId: ObjectTypeId.User,
                trgObjectTypeId: ObjectTypeId.Department,
            })[0]
            if (!t) {
                return ruleset
            }
            rules.push({
                argument: foDepartment_subdepartments
                    ? `[DESCENDANTS;${foDepartment.id};${t[3]};DepartmentNumber;ParentDepartmentNumber]`
                    : (getRawSyncFieldValue(t[3], foDepartment.syncfields) ?? '')
                ,
                argumentoperator: 'Er lik en av',
                attribute: foDepartment_secondaryPositions ? `ParentDepartmentNumber` : `DepartmentNumber`,
            })
        }

        if (foSubdepartment) {
            rules.push({
                attribute: `[Id]`,
                argumentoperator: 'Er lik en av',
                argument: `[DESCENDANTS;${foSubdepartment.id};Id;SourceId;ParentDepartmentNumber]`,
            })
        }

        if (foIdentityType) {
            rules.push({
                argumentoperator: 'Er lik',
                attribute: `[IdentityType]`,
                argument: foIdentityType,
            })
        }

        if (!rules.length) {
            if (hasMultipleImportFormatTypes()) {
                ruleset.rules.push(nsRuleset.generateRule({
                    argumentoperator: 'Har verdi',
                    attribute: 'ObjectTypeId',
                }))
                return ruleset
            }
            return null;
        }

        ruleset.rules = rules.map((r, index: number): IRule => {
            const ret = _.clone(r) as IRule
            ret.order = index + 1
            if (index == 0) {
                ret.booleanoperator = ''
            } else {
                ret.booleanoperator = ret.booleanoperator ?? 'AndAnd'
            }
            return nsRuleset.generateRule(ret);
        });

        return ruleset;
    }

    onSuccess(response: IResponse) {
        this.response = response
        const data = response.data as IObjectData[];
        if (data.length) {
            this.messageData(null);
            this.searchascending(response.sortascending);
            this.searchcolumn(response.sortedby);
            this.searchpagenr(response.pagenr);
            this.searchpages(response.pages);
            this.searchtotalresults(response.totalresults);
            this.data(data);
        } else {
            this.searchpagenr(DEFAULT_SEARCH_PAGE);
            this.searchpages(null);
            this.searchtotalresults(null);
            this.data([]);
        }
    }

    getRealSearchKey() {
        return this.showAll() ? "" : this.searchkey();
    }

    private hasSearchKey(): boolean {
        return this.showAll() || !!this.searchkey();
    }

    /** White-box title key (`*.search`); distinct from route `label` used for tabs / page H1. */
    protected readonly searchBoxHeading = ko.pureComputed(() => getSearchBoxHeadingKey(this.__routeDef));

    /** Heading badge: current hit count when a search is active; hidden while idle. */
    protected readonly searchBadge = ko.pureComputed((): number | null => {
        if (!this.hasSearchKey() || this.isRequesting()) {
            return null;
        }
        return this.searchtotalresults() ?? 0;
    });

    /** Heading spinner while an active search request is in flight. */
    protected readonly searchBadgeWaiting = ko.pureComputed((): boolean => {
        return this.hasSearchKey() && this.isRequesting();
    });

    protected resetSearch(doAbort: boolean = true) {
        if (doAbort) {
            this.req_searchobject.abort()
            this.isRequesting(false)
        }
        this.data([]);
        this.searchpagenr(DEFAULT_SEARCH_PAGE);
        this.searchpages(null);
        this.searchtotalresults(null);
    }

    /*******************************************************************************************************************
     * View interaction
     *******************************************************************************************************************/

    protected onRowClick(item: IObjectData, e: JQuery.Event) {
        if (!this.params.fnValidateRow!(item)) {
            return
        }
        if (this.params.autoSelect) {
            this.getItemCheckbox(item).toggle()
            return
        }
        if (e.metaKey || e.ctrlKey || this.selectedObjects().length) {
            window.open(getChildHash(this.__routeDef, {id: item.id}), '_blank')
        } else {
            setRouteHash(this.__routeDef.child!, item)
        }
    }

    onRowKeyUp = (data: IObjectData, e: JQuery.Event) => {
        if (e.key === 'Enter') {
            this.onRowClick(data, e);
        }
        return true;
    };

    protected notifyAddSelectedObject(item: IObjectData) {
        const name = getSyncFieldDisplayName(this.routeObjectTypeId, item.syncfields);
        let fnUndo: () => void;
        fnUndo = () => this.selectedObjects.remove(item);
        global.snackbarData({message: `subject is added|s:${name}`, undo: fnUndo});
    }

    protected notifyRemoveSelectedObject(item: IObjectData) {
        const name = getSyncFieldDisplayName(this.routeObjectTypeId, item.syncfields);
        const fnUndo = () => this.selectedObjects.push(item);
        global.snackbarData({message: `subject is removed|s:${name}`, undo: fnUndo});
    }

    private numAffectedObjectsText(): string {
        return nsLanguage.getNumObjectsLabel(this.numAffectedObjects(), this.routeObjectTypeId, this.isManual)
    }

    onExportObjectsClick() {
        global.dialogComponent(this.getComponentDialogDefinition(
            `${i('fa-download')} ((export to|to:CSV)) [${this.numAffectedObjectsText()}]`,
            'component/object/dialog/export.csv',
            false,
        ));
    }

    onExportAnchorsClick() {
        global.dialogComponent(this.getComponentDialogDefinition(
            `${i('fa-download-anchor')} ${lm.t('export a to b|a:((anchor|p|ac))|b:CSV')} [${this.numAffectedObjectsText()}]`,
            'component/object/dialog/export.anchors.csv',
            false,
        ));
    }

    onExportMembersClick() {
        global.dialogComponent(this.getComponentDialogDefinition(
            `${i('fa-download-users')} ${lm.t('export a to b|a:((member|p|ac))|b:CSV')} [${this.numAffectedObjectsText()}]`,
            'component/object/dialog/export.members.csv',
            true,
        ));
    }

    onRecreateObjectsClick() {
        global.dialogComponent(this.getComponentDialogDefinition(
            `${i('fa-recycle')} ((restore)) [${this.numAffectedObjectsText()}]`,
            'component/object/dialog/recreate',
            true,
        ));
    }

    onResetPasswordsClick() {
        global.dialogComponent(this.getComponentDialogDefinition(
            `${i('fa-unlock-alt')} ((edit password)) [${this.numAffectedObjectsText()}]`,
            'component/object/dialog/reset.password',
            true,
        ));
    }

    onDeleteObjectsClick() {
        if (this.isManual) {
            global.dialogComponent(this.getComponentDialogDefinition(
                `${i('fa-trash-alt')} ((delete)) [${this.numAffectedObjectsText()}]`,
                'component/object/dialog/delete',
                true,
            ));
        } else {
            global.dialogComponent(this.getComponentDialogDefinition(
                `${i('fa-trash-alt')} ((delete)) [${this.numAffectedObjectsText()}]`,
                'component/object/dialog/purge',
                true,
            ));
        }
    }

    private onCreateCollectionAndRolesClick() {
        const groups = this.selectedObjects();
        const options: IDialogOptionsComponent = {
            title: 'Create permissions from groups',
            content: {
                name: 'component/systemaccess/dialog/groups-to-permissions',
                params: {
                    groups: groups,
                },
            }
        }
        global.dialogManager.addComponent(options)
    }

    private onAssignPermissionsClick() {
        memoryStore.get(WIZARD_PERMISSIONS_PREFILL_USERS_KEY)(_.cloneDeep(this.selectedObjects()));
        setRouteHash('wizardpermissions', {orgnr: global.login.selectedOrganizationId()});
    }

    private onRemoveManualPermissionClick() {
        global.dialogComponent(this.getComponentDialogDefinition(
            `Remove s|s:((manual|ac)) ((permission|ac))`,
            'component/object/dialog/remove.manual.permission',
            true,
            {
                systemid: this.filterOptions.permission()?.system?.id,
                roleid: this.filterOptions.permission()?.role?.id,
            }
        ));
    }

    private getComponentDialogDefinition(title: string, componentName: TComponentName, onlyids: boolean, params: any = {}): IComponentDialogParams {
        const dialog = {
            title: title,
            closeable: ko.observable(true),
        };
        const searchObjectParams = _.defaults({
            resultsprpage: MAX_RESULTS_PER_PAGE,
            pagenr: 0,
            onlyids: onlyids
        }, this.getParams());
        return {
            dialog: dialog,
            component: {
                name: componentName,
                params: _.defaultsDeep(params, {
                    data: this.selectedObjects,
                    dialog: dialog,
                    numTotal: this.numAffectedObjects(),
                    objecttypeid: this.routeObjectTypeId,
                    searchObjectParams: searchObjectParams,
                }),
            }
        };
    }

    // Reset all filter observables.
    onResetClick() {
        if (this.isFilterEnabled(FilterType.Deleted)) {
            this.filterOptions.deleted(1);
        }
        if (this.isFilterEnabled(FilterType.Department)) {
            this.filterOptions.department(null);
        }
        if (this.isFilterEnabled(FilterType.Subdepartment)) {
            this.filterOptions.subdepartment(null);
        }
        if (this.isFilterEnabled(FilterType.ImportCycle)) {
            this.filterOptions.importFile(null);
        }
        if (this.isFilterEnabled(FilterType.Permission)) {
            this.filterOptions.permission(null);
        }
        if (this.isFilterEnabled(FilterType.Ruleset)) {
            this.filterOptions.ruleset(null);
        }
        if (this.isFilterEnabled(FilterType.PermissionType)) {
            this.filterOptions.permissionType('all')
        }
        this.filterOptions.department_subdepartments(null)
        this.filterOptions.department_secondaryPositions(null)
        this.filterOptions.dataSourceType(nsDataSource.getImportFormatType(global.login.selectedOrganization()!.importformat))
    }

    /*******************************************************************************************************************
     * View helpers
     *******************************************************************************************************************/

    protected getRouteHashForItem(type: 'create' | 'read' | 'edit', obj: IObjectData) {
        return getRouteHash(type, this.childRouteDef, undefined, true, obj)
    }

    protected table: KnockoutComputed<ITableColumn[]> = ko.pureComputed(() => {
        return this.getTableDefinition();
    });

    public showTableColumn(key: string): boolean {
        switch (key) {
            case 'selector':
                return this.isSelectable
            case "func":
                return this.pv.isMinSuperEmployee() && !this.isAnySelected();
            default:
                return true;
        }
    }

    isPreviousPageEnabled(): boolean {
        return this.searchpagenr() > 0;
    }

    isNextPageEnabled(): boolean {
        return this.searchpagenr() + 1 < (this.searchtotalresults() ?? 0) / this.searchresultsprpage();
    }

    getPagingText = ko.pureComputed((): string => {
        const isUnknown = this.searchpages() === null;
        const current = isUnknown ? SPINNER : this.searchpagenr() + 1;
        const total = isUnknown ? SPINNER : Math.ceil((this.searchtotalresults() ?? 0) / this.searchresultsprpage());
        return `Side ${current} av ${total}`;
    });

    isExportCsvVisible = ko.pureComputed((): boolean => {
        return true;
    });

    selectedObjectsSorted = ko.pureComputed((): IObjectData[] => {
        const ret: IObjectData[] = _.sortBy(this.selectedObjects(), (item: IObjectData): string => {
            const syncField = getSyncField(this.searchcolumn() as TSyncfield, item.syncfields);
            const syncFieldValue = syncField && syncField.value;
            const itemValue = String((<any>item)[this.searchcolumn()]);
            return syncFieldValue || itemValue;
        });
        return this.searchascending() ? ret : ret.reverse();
    });

    protected getItemCheckbox(item: IObjectData): ItemCheckbox<IObjectData> {
        return new ItemCheckbox({
            item: item,
            key: this.allCheckbox.key,
            selected: this.selectedObjects,
        })
    }

    // either the number of selected objects or the number of search results
    numAffectedObjects = ko.pureComputed((): number => this.selectedObjects().length || (this.searchtotalresults() ?? 0));

    // If any filter has a truthy value the search is filtered.
    isFiltered = ko.pureComputed(() => this._isFiltered());

    protected _isFiltered(): boolean {
        return [
            this.filterOptions.deleted() != 1,
            this.filterOptions.department() && this.routeObjectTypeId == ObjectTypeId.User,
            this.filterOptions.importFile(),
            this.filterOptions.permission() && this.routeObjectTypeId == ObjectTypeId.User,
            this.filterOptions.ruleset(),
            this.filterOptions.subdepartment(),
            this.filterOptions.dataSourceType() != nsDataSource.getImportFormatType(global.login.selectedOrganization()!.importformat),
        ].some(Boolean);
    }

    isFilterAvailable(filterType: FilterType) {
        const pv = this.pv;
        switch (filterType) {
            case FilterType.Deleted:
                return pv.isMinSuperEmployee();
            case FilterType.Department:
                return pv.isMinSuperEmployee() && this.routeObjectTypeId == ObjectTypeId.User;
            case FilterType.ImportCycle:
                return pv.isMinCompanyAdmin();
            case FilterType.Permission:
                return pv.isMinSuperEmployee() && this.routeObjectTypeId == ObjectTypeId.User;
            case FilterType.SystemRole:
                return pv.isMinCompanyAdmin() && this.routeObjectTypeId == ObjectTypeId.User;
            case FilterType.Ruleset:
                return pv.isMinSuperEmployee();
            case FilterType.Subdepartment:
                return this.routeObjectTypeId == ObjectTypeId.Department
            case FilterType.DataSourceType:
                return [ObjectTypeId.User, ObjectTypeId.Department, ObjectTypeId.Group].includes(this.routeObjectTypeId) && hasMultipleImportFormatTypes()
            case FilterType.IdentityType:
                return this.routeObjectTypeId == ObjectTypeId.User && this.filterOptions.dataSourceType() == 'edu'
        }
    }

    isFilterEnabled(filterType: FilterType): boolean {
        // inherited classes should override this implementation when certain filter types should not be enabled
        return true;
    }

    isOperationAvailable(operationType: OperationType) {
        const isUser = this.routeObjectTypeId == ObjectTypeId.User;
        const isManual = this.isManual;
        const isGroup = this.routeObjectTypeId == ObjectTypeId.Group;
        const isApiUser = this.routeObjectTypeId == ObjectTypeId.ApiUser;
        switch (operationType) {
            case OperationType.ExportAnchor:
                return isUser && !isManual;
            case OperationType.ExportMembers:
                return !isManual && isGroup;
            case OperationType.Delete: {
                if (!isManual && this.routeObjectTypeId == ObjectTypeId.ApiUser) {
                    return false
                }
                const a = isManual && this.pv.isMinCompanyAdmin();
                const b = this.pv.isMinOrganizationAdmin();
                return a || b;
            }
            case OperationType.Export:
                return true;
            case OperationType.Recreate:
                return !isManual;
            case OperationType.ResetPasswords: {
                const a = !isManual
                const b = canManageOthersPassword();
                switch (this.routeObjectTypeId) {
                    case ObjectTypeId.User: {
                        return a && b;
                    }
                    case ObjectTypeId.ApiUser: {
                        const c = this.pv.isMinCompanyAdmin();
                        return a && b && c;
                    }
                    default: {
                        return false
                    }
                }
            }
            case OperationType.AssignPermissions:
                return !isManual && isUser && this.pv.isMinSuperEmployee();
            case OperationType.CreateSystemAccessAndRoles:
                return !isManual && isGroup
            case OperationType.RemoveManualPermission:
                return !isManual && isUser
        }
    }

    showFilterButton(): boolean {
        return !this.isManual && [
            FilterType.Deleted,
            FilterType.Department,
            FilterType.Permission,
            FilterType.Ruleset,
        ].some(this.isFilterAvailable.bind(this));
    }

    showOperationsButton(): boolean {
        return !!(this.__routeDef.showMultiOperations && this.isSelectable && this.numAffectedObjects() && [
            OperationType.ExportAnchor,
            OperationType.Delete,
            OperationType.Export,
            OperationType.Recreate,
            OperationType.ResetPasswords,
            OperationType.AssignPermissions,
            OperationType.CreateSystemAccessAndRoles,
        ].some(this.isOperationAvailable.bind(this)));
    }

    protected showSelectedList: KnockoutComputed<boolean> = ko.pureComputed((): boolean => {
        return this.isAnySelected() && this.isSelectable;
    });

    /** Stored columns are missing for object types without a search-column default, so fall back to the constant. */
    protected getInitialSearchColumn(): string {
        const storedKeys: string[] | undefined = storeObservable(`search.object.syncfields${this.routeObjectTypeId}` as TStoreId)();
        const keys = storedKeys?.length ? storedKeys : DEFAULT_SEARCH_COLUMNS[this.routeObjectTypeId] ?? [];
        return keys[0] ?? '';
    }

    protected getRowBindings(...args: [IObjectData]): Record<string, unknown> {
        return _.defaultsDeep(this.params.getRowBindings!(args[0]), {
            click: this.onRowClick.bind(this),
            event: {keyup: this.onRowKeyUp.bind(this)},
            attr: {tabindex: 0},
        });
    }

    private getSelectedListActions(): ISelectedListActions {
        const caller = ko.unwrap(this.params.selectedListActions) ?? {};
        const callerQuick = caller.quickActions ?? [];
        const callerMore = caller.moreActions ?? [];

        if (!this.showOperationsButton()) {
            return {quickActions: callerQuick, moreActions: callerMore};
        }

        const enabled = () => !!this.selectedObjects().length

        const btnExportToCsv: IDropdownButton = {
            enabled,
            onClick: () => this.onExportObjectsClick(),
            label: 'export to|to:' + lm.t('csv|uc'),
            validator: () => this.isOperationAvailable(OperationType.Export),
        }
        const btnExportAnchor: IDropdownButton = {
            enabled,
            onClick: () => this.onExportAnchorsClick(),
            label: 'export a to b|a:((anchor|p|ac))|b:((csv|uc))',
            validator: () => this.isOperationAvailable(OperationType.ExportAnchor),
        }
        const btnExportMembers: IDropdownButton = {
            enabled,
            onClick: () => this.onExportMembersClick(),
            label: 'export a to b|a:((member|p|ac))|b:((csv|uc))',
            validator: () => this.isOperationAvailable(OperationType.ExportMembers),
        }
        const btnRecreate: IDropdownButton = {
            enabled,
            onClick: () => this.onRecreateObjectsClick(),
            label: 'restore',
            validator: () => this.isOperationAvailable(OperationType.Recreate),
        }
        const btnResetPasswords: IDropdownButton = {
            enabled,
            onClick: () => this.onResetPasswordsClick(),
            label: 'change password',
            validator: () => this.isOperationAvailable(OperationType.ResetPasswords),
        }
        const btnAssignPermissions: IDropdownButton = {
            enabled,
            onClick: () => this.onAssignPermissionsClick(),
            label: 'assign permission|p',
            validator: () => this.isOperationAvailable(OperationType.AssignPermissions),
        }
        const btnDelete: IDropdownButton = {
            cls: 'btn-separated btn-danger btn-ready-calm',
            enabled,
            onClick: () => this.onDeleteObjectsClick(),
            label: 'Delete',
            validator: () => this.isOperationAvailable(OperationType.Delete),
        }
        const btnCreateCollectionAndRoles: IDropdownButton = {
            enabled,
            onClick: () => this.onCreateCollectionAndRolesClick(),
            label: 'Create s|s:((permission|p|ac))',
            validator: () => this.isOperationAvailable(OperationType.CreateSystemAccessAndRoles),
        }
        const btnRemoveManualPermission: IDropdownButton = {
            enabled,
            onClick: () => this.onRemoveManualPermissionClick(),
            label: `Remove s|s:((manual|ac)) ((permission|ac))`,
            validator: () => this.isOperationAvailable(OperationType.RemoveManualPermission),
        }

        return {
            quickActions: [...callerQuick, btnExportToCsv],
            moreActions: [
                ...callerMore,
                btnExportAnchor,
                btnExportMembers,
                btnRecreate,
                btnResetPasswords,
                btnAssignPermissions,
                btnCreateCollectionAndRoles,
                btnRemoveManualPermission,
                btnDelete,
            ],
        }
    }

    private buildSearchSplitButtonParams(): Pick<ISplitButtonParams, 'mainButton' | 'buttons'> | null {
        if (!this.isManual) {
            return null
        }

        let mainButton: IDropdownButton
        let buttons: IDropdownButton[]

        switch (this.routeObjectTypeId) {
            case ObjectTypeId.User: {
                mainButton = getRouteDropdownButton('wizardcreateuser', {
                    cls: 'btn-action',
                    icon: 'fa-plus',
                    label: 'manualusers.actions.wizard',
                })
                buttons = [
                    getRouteDropdownButton('uploadmanualusers', {
                        cls: 'btn-action',
                        label: 'manualusers.actions.uploadfromfile',
                    }),
                    getRouteDropdownButton('createmanualuser', {
                        cls: 'btn-action',
                        label: 'manualusers.actions.createsource',
                    }),
                ]
                break
            }
            case ObjectTypeId.Department: {
                mainButton = getRouteDropdownButton('uploadmanualdepartments', {
                    cls: 'btn-action',
                    label: 'manualdepartments.actions.uploadfromfile',
                })
                buttons = [
                    getRouteDropdownButton('createmanualdepartment', {
                        cls: 'btn-action',
                        label: 'manualdepartments.actions.createsource',
                    }),
                ]
                break
            }
            case ObjectTypeId.Group: {
                mainButton = getRouteDropdownButton('wizardcreategroup', {
                    cls: 'btn-action',
                    icon: 'fa-plus',
                    label: 'manualgroups.actions.wizard',
                })
                buttons = [
                    getRouteDropdownButton('uploadmanualgroups', {
                        cls: 'btn-action',
                        label: 'manualgroups.actions.uploadfromfile',
                    }),
                    getRouteDropdownButton('createmanualgroup', {
                        cls: 'btn-action',
                        label: 'manualgroups.actions.createsource',
                    }),
                ]
                break
            }
            case ObjectTypeId.ApiUser: {
                mainButton = getRouteDropdownButton('createmanualapiuser', { cls: 'btn-action', icon: 'fa-plus' })
                buttons = []
                break
            }
            default:
                return null
        }

        return {mainButton, buttons}
    }

    /** Ordered create actions on manual user/group/department searches; null otherwise. */
    private getManualCreateActions(): IDropdownButton[] | null {
        const params = this.searchSplitButtonParams()
        const hasCreateMenu = this.isManual && [
            ObjectTypeId.User,
            ObjectTypeId.Department,
            ObjectTypeId.Group,
        ].includes(this.routeObjectTypeId)
        if (!params || !hasCreateMenu) {
            return null
        }
        const mainButtons = params.mainButton
            ? Array.isArray(params.mainButton) ? params.mainButton : [params.mainButton]
            : []
        return [...mainButtons, ...(params.buttons ?? [])]
    }

    private getActionButtons(): IDropdownButton[] {
        const createActions = this.getManualCreateActions()
        if (createActions) {
            return createActions
        }
        const params = this.searchSplitButtonParams()
        if (!params?.mainButton || this.routeObjectTypeId !== ObjectTypeId.ApiUser) return []
        return Array.isArray(params.mainButton) ? params.mainButton : [params.mainButton]
    }

    /** Extra header menu (e.g. ApiUser); omitted when create actions are already inline. */
    private getMoreOptionsDropdown() {
        if (this.getManualCreateActions()) {
            return null
        }
        return {
            buttons: this.searchSplitButtonParams()?.buttons ?? [],
            icon: 'fal fa-chevron-down',
            btnClass: 'btn btn-default btn-more-options',
            title: 'more options',
        }
    }

    /*******************************************************************************************************************
     * Miscellaneous
     *******************************************************************************************************************/

    protected searchMessage = ko.pureComputed((): IMessageData | null => {
        if (this.messageData()) {
            return this.messageData()
        }
        if (this.data().length) {
            return null
        }
        if (this.hasSearchKey() && (!this.isRequesting() || this.searchtotalresults() == 0)) {
            return {message: nsSearch.MessageNoResult}
        }
        if (this.hasSearchKey() || this.isRequesting()) {
            return {message: nsSearch.MessageLoading};
        }
        return {message: nsSearch.MessageInitial};
    });

    protected getSyncFieldValue(key: string | TSyncfield, obj: IObjectData) {
        const isSearchable = !!this.table().find((item: ITableColumn) => item.key == key && item.sort);

        if (this.routeObjectTypeId == ObjectTypeId.User) {
            const searchKey = this.getRealSearchKey();
            if (isSearchable && searchKey) {
                switch (key) {
                    case 'GivenName':
                    case 'Surname':
                        const isGn = this.table().find((item: ITableColumn) => item.key == 'GivenName');
                        const isSn = this.table().find((item: ITableColumn) => item.key == 'Surname');

                        if (isGn && isSn) {
                            const dn: string = getSyncFieldValue('DisplayName', obj.syncfields);
                            const gn: string = getSyncFieldValue('GivenName', obj.syncfields);
                            const sn: string = getSyncFieldValue('Surname', obj.syncfields);

                            const regExp = new RegExp(getWhiteWashedSearchKey(this.searchkey()), 'gi')
                            let match: RegExpExecArray | null
                            const indexes: number[] = []
                            while ((match = regExp.exec(dn)) != null) {
                                indexes.push(match.index)
                            }
                            const indexMarkStart = indexes.find(index => {
                                const withinGn = index <= gn.length;
                                const beyondGn = index + this.searchkey().length > gn.length;
                                return withinGn && beyondGn
                            })
                            if (indexMarkStart !== undefined) {
                                switch (key) {
                                    case 'GivenName': {
                                        if (indexMarkStart >= gn.length) {
                                            break;
                                        }
                                        return getSearchMarkup(gn.slice(0, indexMarkStart), this.searchkey()) + '<mark>' + gn.slice(indexMarkStart) + '</mark>'
                                    }
                                    case 'Surname': {
                                        const space = 1;
                                        const gnMarkLength = gn.length - indexMarkStart
                                        const snMarkLength = this.searchkey().length - (gnMarkLength + space)
                                        if (snMarkLength > 0) {
                                            return '<mark>' + sn.slice(0, snMarkLength) + '</mark>' + getSearchMarkup(sn.slice(snMarkLength), this.searchkey())
                                        }
                                    }
                                }
                            }
                        }
                }
            }
        }

        let ret: any
        if (key == 'id' || key == 'Id') {
            ret = obj.id
        } else {
            ret = getSyncFieldValue(key as TSyncfield, obj.syncfields);
        }
        if (this.showAll()) {
            return ret;
        }
        if (isSearchable && this.getRealSearchKey()) {
            if (_.isString(ret)) {
                ret = getSearchMarkup(ret, this.searchkey())
            }
        }

        return ret;
    }

    protected getCellTitle(key: string, obj: IObjectData): string | number | null {
        switch (key) {
            case 'id':
                return obj.id;
            default:
                return null;
        }
    }

    private isRulesetNestedDelete = ko.pureComputed((): boolean => {
        const rs = this.filterOptions.ruleset();
        const all = this.allRulesets();
        if (rs && all.length) {
            return nsRuleset.isRulesetNestedDelete(rs, all);
        }
        return false;
    })

    private getFilterOptionHrFileText(obj: IImportHrFile): string {
        return getHrFileDate(obj);
    }

    private getHash = getHash

    private getComboboxParams_ruleset(): IComboboxOptions_Ruleset {
        return {
            comboboxOptions: {
                inputAttrs: {placeholder: lm.t('none selected')},
                option: {
                    label: o => o.name,
                    tooltip: o => o ? (lm.t(nsTooltip.getTitle_ruleset(o) ?? '') ?? '') : '',
                },
                selected: this.filterOptions.ruleset,
            },
            objectTypeIds: this.routeObjectTypeId,
            showIcon: true,
        }
    }

    private getComboboxParams_importHistory(): IComboboxV2Options<IImportHrFile> {
        const listSource = createServiceListPromise<IImportHrFile>({
            name: 'searchimporthrfile',
            params: getSearchParamsFn('searchimporthrfile')({
                asc: false,
                resultsprpage: 20,
                sortcol: 'id',
            }),
        })
        return {
            prepareData: {
                sort: (arr: IImportHrFile[]) => _.sortBy(arr, (o: IImportHrFile) => o.id).reverse(),
            },
            inputAttrs: {placeholder: lm.t('none selected')},
            option: {
                sortBy: [Boolean],
                label: o => `${getDateTime(o.started, false)} [${lm.t(o.sequencenr ? `((Delta)) #${o.sequencenr}` : 'Full')}]`,
                tooltip: o => o ? (lm.t(nsTooltip.getTitle_importHrFile(o) ?? '') ?? '') : '',
            },
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            selected: this.filterOptions.importFile,
        }
    }

    private getComboboxParams_systemRole(): IComboboxOptions_SystemRole {
        const roleid = this.routeOptions?.roleid
        const systemid = this.routeOptions?.systemid
        let initialMatch: ((o: ICustomSystemAccess) => boolean) | undefined
        if (roleid || systemid) {
            this.filterOptions.permission(null)
            if (roleid) {
                initialMatch = o => o.role?.id == roleid
            } else if (systemid) {
                initialMatch = o => o.system?.id == systemid
            }
        }
        return {
            comboboxOptions: {
                inputAttrs: {placeholder: lm.t('none selected')},
                selected: this.filterOptions.permission,
                ...(initialMatch ? {initialMatch} : {}),
            },
            showIcon: true,
            // Filter: include systems the viewer cannot assign; role AvailableTo still applies.
            skipSystemAvailableTo: true,
        }
    }

    private getComboboxParams_department(): IComboboxOptions_Department {
        return {
            comboboxOptions: {
                inputAttrs: {placeholder: lm.t('none selected')},
                enable: this.isFilterEnabled(FilterType.Department),
                initialMatch: o => this.isInitialDepartment?.(o) ?? false,
                selected: this.filterOptions.department,
            },
            showIcon: true,
        }
    }

    private getComboboxParams_subdepartment(): IComboboxOptions_Department {
        return _.defaultsDeep({
            comboboxOptions: {
                enable: this.isFilterEnabled(FilterType.Subdepartment),
                selected: this.filterOptions.subdepartment,
            }
        }, this.getComboboxParams_department())
    }

    private isCheckboxesAvailable(): boolean {
        return this.isSelectable && !!this.table().find(o => o.key == 'selector')
    }

    /** Search result ids that pass `fnValidateRow` (id-only checks use a minimal stub). */
    private getSelectableSearchIds(): number[] {
        return this.data_currentSearch_ids().filter(id =>
            this.params.fnValidateRow!({id} as IObjectData),
        )
    }

    protected markText(key: ITableColumn['key'], haystack: string): string {
        if (!this.isSearchableColumn(key) || this.showAll() || !this.searchkey()) {
            return haystack
        }
        return getSearchMarkup(haystack, this.searchkey())
    }

    protected isSearchableColumn(key: ITableColumn['key']): boolean {
        const searchableColumns = this.response?.searchablecolumns as string[] | undefined;
        return searchableColumns
                ?.map((s: string) => s.toLowerCase())
                .includes(String(key).toLowerCase())
            ?? false
    }

    override dispose() {
        super.dispose();
        pubsub.off(this);
        this.kosub.unsuscribeAll();
        this.req_searchobject_ids?.abort()
        this.req_searchobject?.abort()
        this.isRequesting(false)
        this.req_syncfields?.promise.abort()
        Object.keys(this.requests).forEach((k) => {
            this.requests[k as TServiceName]?.abort()
        })
    }

}
